/**
 * useBeforeUnload Hook
 * Warns users before leaving the page if there are unsaved changes
 */

import { useEffect } from 'react';

const useBeforeUnload = (hasUnsavedChanges, message = 'You have unsaved changes. Are you sure you want to leave?') => {
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (hasUnsavedChanges) {
                event.preventDefault();
                event.returnValue = message;
                return message;
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [hasUnsavedChanges, message]);
};

export default useBeforeUnload;
